import React, { useEffect, useRef, useState } from "react";

const SECONDS_PER_ITEM = 4;

const Ticker = ({ items, ViewComponent }) => {
  const [displayed, setDisplayed] = useState(items);
  const trackRef = useRef(null);
  const pendingRef = useRef(items);

  pendingRef.current = items;

  useEffect(() => {
    const sameSet =
      displayed.length === items.length &&
      displayed.every((d, i) => d.user === items[i].user);

    if (sameSet) {
      setDisplayed(items);
      return;
    }

    if (displayed.length === 0) {
      setDisplayed(items);
      return;
    }

    const node = trackRef.current;
    if (!node) return;

    const handler = () => setDisplayed(pendingRef.current);
    node.addEventListener("animationiteration", handler, { once: true });
    return () => node.removeEventListener("animationiteration", handler);
  }, [items, displayed]);

  if (!displayed || displayed.length === 0) return null;

  const trackKey = displayed.map((d) => d.user).join("|");
  const duration = `${displayed.length * SECONDS_PER_ITEM}s`;

  return (
    <div className="ticker-viewport">
      <div
        key={trackKey}
        ref={trackRef}
        className="ticker-track"
        style={{ animationDuration: duration }}
      >
        {displayed.map((item) => (
          <ViewComponent data={item} key={`a-${item.user}`} />
        ))}
        {displayed.map((item) => (
          <ViewComponent data={item} key={`b-${item.user}`} aria-hidden />
        ))}
      </div>
    </div>
  );
};

export default Ticker;
